import { RemoteCreateQuestion } from 'data/usecases';
import { makeApiUrlEvaluationCriteriaQuestions } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateQuestion = (): RemoteCreateQuestion => {
  return new RemoteCreateQuestion(
    makeApiUrlEvaluationCriteriaQuestions(),
    makeAxiosHttpClient(),
  );
};
